import Contract from 'domain/contract';
import { ContractSignatureStatus, getContractSignatureStatusTextClass } from 'domain/contractSignatureStatus';
import { ContractSignerType } from 'domain/contractSignerType';
import React from 'react';

interface ESignStatusProps {
    status: string;
    contract: Contract;
    isCustomer: boolean;
    onSelected(): void;
}

const ESignStatus: React.FC<ESignStatusProps> = React.memo(props => {
    const statusClass = getContractSignatureStatusTextClass(props.contract, props.isCustomer);

    if (!props.isCustomer && props.contract?.eSignatureStatus === ContractSignatureStatus.Sent && props.contract.eSignatureAwaitingSignerType === ContractSignerType.Merchant) {
        return (
            <button className={`d-flex align-items-center link-button text-info}`} onClick={() => props.onSelected()} >
                {props.status} <i className="material-icons text-info">draw</i>
            </button>
        );
    }

    return <span className={statusClass}>{props.status}</span>;
});

export default ESignStatus;